
import { MdDashboard, MdWork } from "react-icons/md";
import Dashboard from "../Pages/Dashboard";
import { FaUsers } from "react-icons/fa6";
import Users from "../Pages/Users/Users";

import CreateUser from "../Pages/Users/CreateUser";
import PreviewUser from "../Pages/Users/PreviewUser";
import EditUser from "../Pages/Users/EditUser";
import { GiCash } from "react-icons/gi";
import Plans from "../Pages/Plans/Plans";
import CreatePlan from "../Pages/Plans/CreatePlan";
import EditPlan from "../Pages/Plans/EditPlan";
import PendingUsers from "../Pages/Users/PendingUser";
import { RiPassValidLine } from "react-icons/ri";
import PlanValidity from "../Pages/Plans/PlanValidity";
import ManageImages from "../Pages/Users/ManageImages";
import { MdOutlineConnectWithoutContact } from "react-icons/md";
import { TbPasswordUser } from "react-icons/tb";
import Enquiries from "../Pages/Common/enquiries";
import Professions from "../Pages/Menus/Professions";
import ChangePassword from "../Pages/Users/ChangePassword";

export const sideRoutes = [
    {
        link: '/' || '/dashboard',
        title: 'Dashboard',
        TitleIcon: MdDashboard,
        component: Dashboard,
    },
    {
        link: '/user',
        title: 'User',
        TitleIcon: FaUsers,
        component: Users
    },
    {
        link: '/plan',
        title: 'Plans',
        TitleIcon: GiCash,
        component: Plans
    },
    {
        link: '/professions',
        title: 'Professions',
        TitleIcon: MdWork,
        component: Professions
    },
    {
        link: '/planValidity',
        title: 'Plan Validity',
        TitleIcon: RiPassValidLine,
        component: PlanValidity
    },
    {
        link: '/enquiries',
        title: 'Enquiries',
        TitleIcon: MdOutlineConnectWithoutContact,
        component: Enquiries
    },
    {
        link: '/changePassword',
        title: 'Change Passsord',
        TitleIcon: TbPasswordUser,
        component: ChangePassword
    }
]

export const OtherRoutes = [
    {
        title: 'Create User',
        link: '/createUser',
        component: CreateUser
    },
    {
        title: 'View User',
        link: "/view/:id",
        component: PreviewUser
    },
    {
        title: 'Edit User',
        link: "/edit/:id",
        component: EditUser
    },
    {
        title: 'Create Plan',
        link: '/createPlan',
        component: CreatePlan
    },
    {
        title: 'Edit Plan',
        link: '/editPlan/:id',
        component: EditPlan
    },
    {
        title: 'Pending Users',
        link: '/user/:status',
        component: PendingUsers
    },
    {
        title: 'Manage Images',
        link: '/manageImages/:id',
        component: ManageImages
    },
]

export const CombinedRoutes = [...OtherRoutes, ...sideRoutes]